module.exports = __webpack_public_path__ + "img/休闲观光.eff21d1f.png";